"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIPO_LOGIN = void 0;
exports.TIPO_LOGIN = { RUT: 0, USERNAME: 1 };
